import {Routes} from '@angular/router';
import {PlatformLinkCreatorComponent} from '@shared/components/platform-tool/platform-link-creator/platform-link-creator.component';

export const NewsletterRoutes: Routes = [
  {
    path: 'taxnews/newsletter',
    component: PlatformLinkCreatorComponent
  }
];
